import { Route } from '@angular/router';
import { AccessTypeE, PublicRestService, RestNaseptatCiselnikService, RestSablonaService } from '@generated/be';
import { AppRoutes, canActivateByAccess } from '@reza-ais-fe/reza-ais-fe-utils';
import { AppCanActivate, ApplicationModule } from '@shared/utils';
import { LandingPageComponent } from '../pages/landing-page/landing-page.component';
import { SeznamSablonMainPageComponent } from '../pages/seznam-sablon/main.component';
import { SeznamSablonStateService } from '../services/seznam-sablon-state.service';
import { LoginComponent } from './../pages/login/login.component';
import { ProtectedComponent } from './components/protected/Protected.component';
import { DefaultLayoutComponent } from './layouts/default/default-layout.component';
import { WithoutRezaLayoutComponent } from './layouts/without-reza/without-reza-layout.component';
import { NotFoundPageComponent } from '../pages/not-found.page';
import { KatalogSkupinSablonMainPageComponent } from '../pages/katalog-skupin-sablon/main.component';
import { KatalogSkupinSablonStateService } from '../services/katalog-skupin-sablon-state.service';

export const appRoutes: Route[] = [
  {
    path: '',
    component: DefaultLayoutComponent,
    // canActivate: [RootAuthGuard],
    children: [
      {
        path: '',
        component: LandingPageComponent,
        data: { hideBreadcrumb: true, publicFooter: true },
      },
      {
        path: `${AppRoutes.Dms}`,
        loadChildren: () => import('@features/dms').then((m) => m.DMS_ROUTES),
        data: {
          breadcrumbs: 'Dokumentace',
          applicationModule: ApplicationModule.Chyba,
        },
      },
      {
        path: '',
        component: ProtectedComponent,
        canActivate: [AppCanActivate],
        children: [
          {
            path: `${AppRoutes.Opravneni}`,
            loadChildren: () => import('@features/opravneni').then((m) => m.OPRAVNENI_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.Opravneni)],
            data: {
              breadcrumbs: 'Správa oprávnění k zastupování',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Sablony}`,
            loadChildren: () => import('@features/sablony').then((m) => m.SABLONY_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.Sablony, AccessTypeE.SablonyVytvareni)],
            data: {
              breadcrumbs: 'Správa šablon',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Sablony_Skupiny}`,
            loadChildren: () => import('@features/sablony').then((m) => m.SABLONY_SKUPINY_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.SablonySkupiny, AccessTypeE.SablonySkupinyVytvareni)],
            data: {
              breadcrumbs: 'Správa skupin šablon',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Certifikaty}`,
            loadChildren: () => import('@features/certifikaty').then((m) => m.CERTIFIKATY_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.Certifikaty)],
            data: {
              breadcrumbs: 'Certifikáty',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Ciselniky}`,
            loadChildren: () => import('@features/ciselniky').then((m) => m.CISELNIKY_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.Ciselniky)],
            data: {
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.CertifikatyOvereni}`,
            loadChildren: () => import('@features/certifikaty-overeni').then((m) => m.CERTIFIKATY_OVERENI_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.CertifikatyOvereni)],
            data: {
              breadcrumbs: 'Ověření certifikátu',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Statistiky}`,
            loadChildren: () => import('@features/statistiky').then((m) => m.STATISTIKY_ROUTES),
            canActivate: [
              canActivateByAccess(
                AccessTypeE.StatistikyOkz,
                AccessTypeE.StatistikySablony,
                AccessTypeE.StatistikyCertifikaty
              ),
            ],
            data: {
              breadcrumbs: 'Statistiky',
              applicationModule: ApplicationModule.Chyba,
              disabled: true,
            },
          },
          {
            path: `${AppRoutes.Reklamace}`,
            loadChildren: () => import('@features/reklamace').then((m) => m.REKLAMACE_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.Reklamace)],
            data: {
              breadcrumbs: 'Reklamace',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Reklamace_ImplicitnichOpravneni}`,
            loadChildren: () => import('@features/reklamace').then((m) => m.REKLAMACE_IMPLICITNICH_OPRAVNENI_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.ReklamaceImpl)],
            data: {
              breadcrumbs: 'Reklamace implicitních oprávnění',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Reklamace_KontrolaReklamaciImplicitnichOpravneni}`,
            loadChildren: () =>
              import('@features/reklamace').then((m) => m.KONTROLA_REKLAMACI_IMPLICITNICH_OPRAVNENI_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.ReklamaceImpl)], // TODO
            data: {
              breadcrumbs: 'Kontrola reklamací implicitních oprávnění',
              applicationModule: ApplicationModule.Chyba,
            },
          },
          {
            path: `${AppRoutes.Archiv}`,
            loadChildren: () => import('@features/archivace').then((m) => m.ARCHIVACE_ROUTES),
            canActivate: [
              canActivateByAccess(
                AccessTypeE.ArchivaceOkz,
                AccessTypeE.ArchivaceSablony,
                AccessTypeE.ArchivaceCertifikaty
              ),
            ],
            data: {
              breadcrumbs: 'Archiv',
              applicationModule: ApplicationModule.Chyba,
              disabled: true,
            },
          },
          {
            path: `${AppRoutes.OvereniOpravneni}`,
            loadChildren: () => import('@features/overeni-opravneni').then((m) => m.OPRAVNENI_OVERENI_ROUTES),
            canActivate: [canActivateByAccess(AccessTypeE.OpravneniOvereni)],
            data: {
              breadcrumbs: 'Ověření oprávnění',
              applicationModule: ApplicationModule.Chyba,
              disabled: true,
            },
          },
          {
            path: `${'playground'}`, // playground je pouze pro testování a nastaven na všechny role
            loadChildren: () => import('@features/playground').then((m) => m.PLAYGROUND_ROUTES),
            // canActivate: [
            //   canActivateByAccess(
            //     AccessTypeE.Opravneni,
            //     AccessTypeE.SablonyVytvareni,
            //     AccessTypeE.Sablony,
            //     AccessTypeE.OpravneniOvereni,
            //     AccessTypeE.Reklamace,
            //     AccessTypeE.ReklamaceSpravce,
            //     AccessTypeE.StatistikyOkz,
            //     AccessTypeE.StatistikySablony,
            //     AccessTypeE.StatistikyCertifikaty,
            //     AccessTypeE.ArchivaceOkz,
            //     AccessTypeE.ArchivaceSablony,
            //     AccessTypeE.ArchivaceCertifikaty,
            //     AccessTypeE.Certifikaty,
            //     AccessTypeE.CertifikatyOvereni,
            //     AccessTypeE.OpravneniUkonceni
            //   ),
            // ],
            data: {
              breadcrumbs: 'Playground',
            },
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: WithoutRezaLayoutComponent,
    children: [
      {
        path: AppRoutes.SeznamSablon,
        data: { breadcrumbs: 'Katalog typu oprávněná k zastupování' },
        component: SeznamSablonMainPageComponent,
        providers: [SeznamSablonStateService, RestSablonaService, RestNaseptatCiselnikService, PublicRestService],
      },
      {
        path: AppRoutes.KatalogSkupinSablon,
        data: { breadcrumbs: 'Katalog skupin typu oprávnění k zastupování' },
        component: KatalogSkupinSablonMainPageComponent,
        providers: [
          KatalogSkupinSablonStateService,
          RestSablonaService,
          RestNaseptatCiselnikService,
          PublicRestService,
        ],
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: AppRoutes.Nenalezeno,
        component: NotFoundPageComponent,
        data: { hideBreadcrumb: true, hideNavbar: true },
      },
    ],
  },

  { path: '**', redirectTo: `/${AppRoutes.Nenalezeno}` },
];
